import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Field } from 'react-final-form';
import { RadioField, Text, Box } from 'mdlkit';
import { PatientAffiliation } from '../../../interfaces/register';

const StyledBox = styled(Box)`
  margin-top: ${({ theme }) => theme.space.md}px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radius};
  padding: ${({ theme }) => theme.space.sm}px;
`;

const OptionWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.sm}px;
`;

interface Props {
  affiliations: PatientAffiliation[];
}

const PatientAffiliationList: FunctionComponent<Props> = ({
  affiliations,
}: Props) => (
  <StyledBox>
    <Text as="label" htmlFor="affiliationId" pt="md">
      <FormattedMessage id="multipleUserAccountError.label" />
    </Text>
    <OptionWrapper role="radiogroup" aria-labelledby="affiliation">
      {affiliations.map(({ description, id }) => (
        <Field
          key={id}
          id={`patientAffiliation_${id}`}
          type="radio"
          name="affiliationId"
          label={description}
          component={RadioField}
          value={id.toString()}
        />
      ))}
    </OptionWrapper>
  </StyledBox>
);

export default PatientAffiliationList;
